<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <label for="">{{ $t("module.speed") }}</label>
        <el-slider
          v-model="speed"
          :step="1"
          :min="1"
          :max="speeds.length"
          show-stops
        ></el-slider>
      </div>
    </div>
    <div id="goz_esnetme">
      <div
        style="position: absolute; font-size: 20px"
        :style="{
          top: top + 'px',
          left: left + 'px',
          transform: 'rotate(' + rotate + 'deg)',
          transformOrigin: rotate < 0 ? 'center' : 'center',
        }"
      >
        {{ word }}
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "GozEsnekligi",
  data() {
    return {
      speed: 1,
      speeds: [500, 461, 428, 400, 375, 352, 333],
      words:
        "Lorem Ipsum, dizgi ve baskı endüstrisinde kullanılan mıgır metinlerdir. Lorem Ipsum, adı bilinmeyen bir matbaacının bir hurufat numune kitabı oluşturmak üzere bir yazı galerisini alarak karıştırdığı 1500'lerden beri endüstri standardı sahte metinler olarak kullanılmıştır. Beşyüz yıl boyunca varlığını sürdürmekle kalmamış, aynı zamanda pek değişmeden elektronik dizgiye de sıçramıştır. 1960'larda Lorem Ipsum pasajları da içeren Letraset yapraklarının yayınlanması ile ve yakın zamanda Aldus PageMaker gibi Lorem Ipsum sürümleri içeren masaüstü yayıncılık yazılımları ile popüler olmuştur.".split(
          " "
        ),
      top: 0,
      left: 0,
      word: null,
      rotate: 0,
    };
  },
  mounted() {
    this.wrapper = {
      width: document.getElementById("goz_esnetme").clientWidth,
      height: document.getElementById("goz_esnetme").clientHeight,
    };

    this.start();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    start() {
      this.interval = setInterval(() => {
        this.$store.state.ticks[this.$store.state.selectedTick2].play();
        this.top = _.random(100, this.wrapper.width - 100);
        this.left = _.random(100, this.wrapper.height - 100);
        this.rotate = _.random(-100, 130);
        this.word = this.words[_.random(0, this.words.length - 1)];
      }, this.currentSpeed);
    },
    calculateDisplays() {
      if (this.mode == 1) {
        if (this.step == 0) {
          this.shapes = this.shapes.map((k) => "none");
          return;
        }
        this.$set(this.shapes, this.step - 1, "block");
      }
      if (this.mode == 2) {
        this.shapes = this.shapes.map((k) => "none");
        this.$set(this.shapes, this.step - 1, "block");
      }
      if (this.mode == 3 || this.mode == 4) {
        if (this.step > this.maxStepCount / 2) {
          this.$set(this.shapes, this.step - this.maxStepCount / 2 - 1, "none");
        } else {
          this.$set(this.shapes, this.step - 1, "block");
        }
      }
    },
  },
  computed: {
    currentSpeed() {
      return this.speeds[this.speed - 1];
    },
  },
  watch: {
    currentSpeed: function () {
      clearInterval(this.interval);
      this.start();
    },
    mode: function () {
      if (this.mode == 3) {
        this.maxStepCount = 28;
        this.maxShape = 14;
      } else if (this.mode == 4) {
        this.maxStepCount = 10;
        this.maxShape = 5;
      } else if (this.mode == 1) {
        this.maxStepCount = 14;
        this.maxShape = 14;
      } else {
        this.maxStepCount = 14;
        this.maxShape = 14;
      }
      this.step = 0;
      clearInterval(this.interval);
      this.start();
    },
  },
};
</script>

<style lang="less" scoped>
#goz_esnetme {
  width: 700px;
  height: 500px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/modules/GozEsnekligi.vue